import { duration } from "moment";

export const DestinationMapper = (rawData) => {
 
    let transformedData = [];
    let data = rawData?.results
    if(data !== undefined)
    {
        data.forEach((element, index) => {
          let data = [
            element.name,
            element.location,
            element.typeLabel,
            element.difficultyLabel,
            element.maxElevation,
            element.images
          ];

          transformedData.push({
            data: data,
            rawData: element,
          });
        });

        return transformedData;
    }

    return []
    
}

export const AdventureMapper = (rawData) => {
  let transformedData = [];
  let data = rawData?.results;
  if (data !== undefined) {
    data.forEach((element, index) => {
      let data = [
        element.name,
        element.location,
        element.typeLabel,
        element.difficultyLabel,
        element.maxElevation,
        element.startDate,
        element.minimumPrice,
      ];

      transformedData.push({
        data: data,
        rawData: element,
      });
    });

    return transformedData;
  }

  return [];
};

export const CountriesOptionMapper = (rawData) => {
  let data = []
  rawData.forEach((country, index) => {
    data.push({id:country.value, name:country.label})
  })

  return data
}


export const ProgrammeMapper = (rawData) => {
  let transformedData = [];
  let data = rawData?.results;
  if (data !== undefined) {
    data.forEach((element, index) => {
      let data = [
        element.name,
        // element.description,
        `${element.duration} ${element.durationUnits}`,
        element.startDate,
        element.endDate,
       
      ];
      let adventureIds = []
      element.programmeAdventures.forEach(element => {
        adventureIds.push({value:element.adventureId, name:element.name})
      });
      transformedData.push({
        data: data,
        rawData: {
          id: element.id,
          name: element.name,
          startDate: element.startDate,
          endDate: element.endDate,
          description: element.description,
          adventureIds: adventureIds,
          duration: element.duration,
          durationUnits: element.durationUnits,
          priceGroups: element.price.length > 0 ? element.price[0].priceGroups : [],
          paymentPlan: element.paymentPlan,
          bookingLink: element.bookingLink
        },
      });
    });

    return transformedData;
  }

  return [];
};